import { ifSelectorExist, getElement, getElements } from "./utils";

export const videoScroll = () => {
   function isScrolledIntoView(el) {
      let elemTop = el.getBoundingClientRect().top;
      let elemBottom = el.getBoundingClientRect().bottom;

      let isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
      return isVisible;
   }

   let videoEl = document.getElementById('autoPlay');
   let videoWasStarted = false;

   window.addEventListener('scroll', function (e) {
      if (isScrolledIntoView(videoEl) && !videoWasStarted) {
         videoWasStarted = true;
         videoEl.play();
      }
   });
};
